import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {QueryUsersForBusinessArgs as QueryArgs} from "@irati/types"

export interface QueryUsersArgs extends QueryArgs {}

const query = gql`
  query UsersForBusiness($businessId: ID!, $cursor: String, $offset: Int, $nonOnboarded: Boolean) {
    usersForBusiness(businessId: $businessId, cursor: $cursor, offset: $offset, nonOnboarded: $nonOnboarded) {
      total
      cursor
      results {
        uuid
        email
        firstName
        lastName
      }
    }
  }
`

export const nonOnboardedUsersForBusinessKey = getQueryNames(query)[0]

export default query
